import { Phone, MessageCircle, CalendarCheck } from "lucide-react";
import { BUSINESS } from "@/lib/data";

export const StickyCTA = () => (
  <nav data-testid="sticky-mobile-cta" className="sm:hidden fixed bottom-0 left-0 right-0 z-40 grid grid-cols-3 border-t border-white/10 bg-black/95 backdrop-blur-xl">
    <a href={BUSINESS.phoneHref} data-testid="sticky-call-btn" className="flex flex-col items-center gap-1 py-3 text-neutral-200 active:bg-white/5">
      <Phone className="w-4 h-4 text-torch" />
      <span className="font-mono text-[9px] tracking-[0.2em] uppercase">Call</span>
    </a>
    <a href={BUSINESS.whatsapp} target="_blank" rel="noopener noreferrer" data-testid="sticky-whatsapp-btn" className="flex flex-col items-center gap-1 py-3 text-neutral-200 active:bg-white/5 border-x border-white/10">
      <MessageCircle className="w-4 h-4 text-[#25D366]" />
      <span className="font-mono text-[9px] tracking-[0.2em] uppercase">WhatsApp</span>
    </a>
    <a href="#booking" data-testid="sticky-book-btn" className="flex flex-col items-center gap-1 py-3 bg-torch text-white active:bg-torch-hover">
      <CalendarCheck className="w-4 h-4" />
      <span className="font-mono text-[9px] tracking-[0.2em] uppercase font-bold">Book</span>
    </a>
  </nav>
);
